import { selectPanoramaImageByFlightId } from "features/entity-caching/images/panorama/selectors"
import { StatusAndProgressData } from "../generics/GenericLayerListItemProgress"
import { useAppSelector } from "integrations/redux/hooks"
import { SidePanelStatus } from "@nova/component-side-panel-tab-container"
import { useProgressForSingleUploadFlightId } from "@nova/slice-multifile-upload"
import { selectUploadsForSetSummary } from "plugins/Panorama/PanoramaSlice"

export function usePanoramaStatusAndProgress(id: string): StatusAndProgressData {
    const image = useAppSelector(selectPanoramaImageByFlightId(id))
    const summary = useAppSelector(selectUploadsForSetSummary(id))
    const progress = useProgressForSingleUploadFlightId(id)
    const totalUploadCount = summary.uploadCount
    const status = image
        ? undefined
        : !totalUploadCount
          ? SidePanelStatus.empty
          : progress
            ? SidePanelStatus.singleFileUploading
            : SidePanelStatus.upload
    switch (status) {
        case SidePanelStatus.singleFileUploading:
            return {
                status,
                createdAtDate: undefined,
                progress,
                totalUploadCount,
            }
    }
    return {
        status,
    }
}
